import script from "./ProportionalWithdrawalInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProportionalWithdrawalInput.vue?vue&type=script&setup=true&lang=ts"

import "./ProportionalWithdrawalInput.vue?vue&type=style&index=0&id=72c66fcb&scoped=true&lang=css"
script.__scopeId = "data-v-72c66fcb"

export default script